const useFormErrors = (errors = {}) => {
  const hasErrors = Object.keys(errors).length !== 0;
  function getMessage(errorValue) {
    if (typeof errorValue === 'string') {
      return errorValue;
    }
    return errorValue.message;
  }
  const formErrors = Object.entries(errors).map(error => {
    return {
      href: `#${error[0]}`,
      text: getMessage(error[1])
    };
  });
  return [hasErrors, formErrors];
};

export { useFormErrors };
